import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { Alert } from 'react-bootstrap';
import {
  confirmEmail,
  CONFIRMEMAIL_SUCCESS,
  verifyEmail,
  VERIFYEMAIL_SUCCESS
} from '../redux/modules/auth';
import LoadingSpinner from './loading-spinner';

class VerifyEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      confirmationStatus: false,
      loading: false
    };
  }

  sendConfirmation = event => {
    event.preventDefault();
    this.setState({ confirmationStatus: false, error: null, loading: true });

    this.props.confirmEmail({ email: this.props.user.email }).then(action => {
      if (action.type === CONFIRMEMAIL_SUCCESS) {
        this.setState({
          confirmationStatus: this.i18n(
            'Der er nu afsendt en ny mail med din bekræftelseskode - klik på linket i mailen eller indsæt koden ovenfor og tryk "Bekræft".'
          ),
          loading: false
        });
        return action;
      }
      this.setState({
        confirmationStatus: this.i18n(
          'Oops! Something went wrong. Please try again or reach out to our customer support.'
        ),
        error: true,
        loading: false
      });
      return action;
    });
  };

  handleSubmit = event => {
    this.setState({ confirmationStatus: false });
    event.preventDefault();
    const token = this.refs.token.value;
    this.props.verifyEmail({ token }).then(action => {
      if (action.type !== VERIFYEMAIL_SUCCESS) {
        this.setState({
          confirmationStatus: this.i18n(
            'Oops! Something went wrong. Please try again or reach out to our customer support.'
          ),
          error: true,
          loading: false
        });
      }
      return action;
    });
  };

  render() {
    const { confirmationStatus, loading, error } = this.state;
    const { user } = this.props;

    if (!user || user.status || !user.email) {
      return null;
    }

    return (
      <Alert bsStyle={error ? 'danger' : 'warning'}>
        <div className="confirm-email">
          <strong>{this.i18n('Confirm your email address')}</strong>
          <br />
          {this.i18n(
            'You need to confirm your email before we can send your notifications about new dwellings. All you have to do, is click the link in the email we sent you, or copy the confirmation code to the form below.'
          )}
          <br />
          <br />
          <form>
            <div className="form-group row">
              <label className="control-label col-md-4">
                {this.i18n('Confirmation code')}
              </label>
              <div className="col-md-8">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    ref="token"
                    placeholder={this.i18n('Confirmation code')}
                    name="confirmCode"
                    defaultValue=""
                  />
                  <span className="input-group-btn">
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      disabled={loading}
                      className={`btn btn-${loading ? 'default' : 'success'}`}
                    >
                      <i className="fa fa-thumbs-up" />
                      {this.i18n('Confirm')}
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </form>

          {!loading && confirmationStatus ? (
            <div>
              <strong>{confirmationStatus}</strong>
              <hr />
            </div>
          ) : null}

          {loading ? <LoadingSpinner /> : null}

          {this.i18n(
            "Haven't received the confirmation email from us? %r or contact our customer support who will help you.",
            <span className="link" onClick={this.sendConfirmation}>
              {this.i18n('Click here to resend')}
            </span>
          )}
        </div>
      </Alert>
    );
  }
}

export default connect(
  ({ auth: { user } }) => ({ user }),
  { confirmEmail, verifyEmail }
)(i18n(VerifyEmail));
